{
  "toast": {
    "checkYourEmailForASignInLink": "Check votre email pour a sign-in link",
    "ticketCreated": "Ticket créé",
    "proofOfDeliveryConfirmed": "Proof of delivery confirmed",
    "replySent": "Réponse envoyée",
    "ifRegisteredASignInLinkWasSent": "If registered, a sign-in link was sent"
  },
  "errors": {
    "couldNotSwitchPortal": "Impossible de switch portal",
    "couldNotLoadEmployeeProfile": "Impossible de charger employee profile",
    "signInFailed": "Échec de la connexion",
    "couldNotSendSignInLink": "Impossible de send sign-in link",
    "linkInvalidOrExpired": "Link invalid ou expired",
    "couldNotLoadDashboard": "Impossible de charger dashboard",
    "couldNotOpenPortal": "Impossible de open portal",
    "couldNotLoadApplication": "Impossible de charger application",
    "couldNotLoadProfile": "Impossible de charger profile",
    "couldNotLoadTickets": "Impossible de charger tickets",
    "failedToCreateTicket": "Échec de la création de ticket",
    "couldNotLoadDeliveries": "Impossible de charger deliveries",
    "couldNotConfirmPod": "Impossible de confirm POD",
    "couldNotLoadPayroll": "Impossible de charger payroll",
    "couldNotLoadLeaveBalances": "Impossible de charger leave balances",
    "couldNotLoadRfqs": "Impossible de charger rFQs",
    "couldNotLoadPurchaseOrders": "Impossible de charger purchase orders",
    "couldNotLoadBills": "Impossible de charger bills",
    "couldNotLoadPerformance": "Impossible de charger performance",
    "sessionExpired": "Session expiré",
    "replyFailed": "Échec de l'envoi de la réponse",
    "enterOrganizationIdAndEmail": "Saisissez organization ID and email",
    "requestFailed": "Échec de la requête",
    "invalidOrExpiredLink": "Invalid ou expired link",
    "couldNotLoadSection": "Impossible de charger {{section}}"
  },
  "pages": {
    "attendance": "Présence",
    "leaveRequests": "Congé requests",
    "payslips": "Bulletins de paie",
    "partnerWorkspace": "Partner workspace",
    "collaborationAndDocuments": "Collaboration et documents",
    "interviews": "Interviews",
    "offerLetters": "Offer letters",
    "documents": "Documents",
    "onboardingTasks": "Intégration tasks",
    "applicationStatus": "Application status",
    "invoices": "Factures",
    "orders": "Orders",
    "payments": "Paiements",
    "profile": "Profile",
    "supportTickets": "Support tickets",
    "myProfile": "My profile",
    "payroll": "Paie",
    "leaveBalances": "Congé balances",
    "rfqs": "RFQs",
    "purchaseOrders": "Purchase orders",
    "vendorBills": "Vendor bills",
    "performanceScore": "Performance score",
    "payrollSummary": "Résumé de paie",
    "proofOfDelivery": "Preuve de livraison",
    "assignedDeliveries": "Livraisons assignées"
  },
  "labels": {
    "switchPortal": "Switch portal",
    "emailOrMobile": "Email ou mobile",
    "password": "Mot de passe",
    "authenticatorCode": "Code d'authentification",
    "subject": "Subject",
    "description": "Descriptif",
    "describeYourIssue": "Describe votre issue",
    "organizationId": "ID de l'organisation",
    "email": "Email",
    "token": "Jeton",
    "closeMenu": "Fermer le menu",
    "signOut": "Se déconnecter",
    "menu": "Menu",
    "allPortals": "Tous les portails",
    "organization": "Organisation",
    "employeeWithCode": "Employé {{code}}",
    "delivery": "Livraison"
  },
  "empty": {
    "noAttendanceRecordsYet": "Aucun relevé de présence pour le moment.",
    "noLeaveRequestsYet": "Aucune demande de congé pour le moment.",
    "noPayslipsAvailableYet": "Aucun bulletin de paie disponible pour le moment.",
    "noItemsYet": "Aucun élément pour le moment.",
    "payrollInformationNotAvailableYet": "Les informations de paie ne sont pas encore disponibles.",
    "noLeaveBalancesConfigured": "Aucun solde de congés configuré.",
    "noDeliveriesAssigned": "Aucune livraison assignée."
  },
  "portals": {
    "EMPLOYEE": {
      "title": "Portail employé",
      "subtitle": "Votre espace de travail"
    },
    "CUSTOMER": {
      "title": "Portail client",
      "subtitle": "Commandes, factures et assistance"
    },
    "VENDOR": {
      "title": "Portail fournisseur",
      "subtitle": "BC, appels d'offres et paiements"
    },
    "CANDIDATE": {
      "title": "Portail candidat",
      "subtitle": "Candidatures et intégration"
    },
    "DELIVERY": {
      "title": "Portail livraison",
      "subtitle": "Tournées et preuve de livraison"
    },
    "PARTNER": {
      "title": "Portail partenaire",
      "subtitle": "Collaboration et documents"
    }
  },
  "portalNav": {
    "dashboard": "Tableau de bord",
    "profile": "Profil",
    "orders": "Commandes",
    "invoices": "Factures",
    "payments": "Paiements",
    "support": "Assistance",
    "tickets": "Assistance",
    "documents": "Documents",
    "subscriptions": "Abonnements",
    "notifications": "Alertes",
    "purchaseOrders": "Bons de commande",
    "pos": "Bons de commande",
    "rfqs": "Appels d'offres",
    "quotations": "Devis",
    "vendorBills": "Factures fournisseur",
    "bills": "Factures fournisseur",
    "performance": "Performance",
    "attendance": "Présence",
    "leave": "Congés",
    "claims": "Notes de frais",
    "payroll": "Paie",
    "training": "Formation",
    "approvals": "Approbations",
    "applications": "Candidatures",
    "interviews": "Entretiens",
    "offerLetter": "Lettre d'offre",
    "offers": "Lettre d'offre",
    "onboarding": "Intégration",
    "status": "Statut",
    "deliveries": "Livraisons",
    "assigned": "Livraisons",
    "route": "Tournée",
    "proofOfDelivery": "Preuve de livraison",
    "pod": "Preuve de livraison"
  },
  "vendorPortal": {
    "empty": {
      "noBills": "Aucune facture pour le moment.",
      "noPurchaseOrders": "Aucun bon de commande pour le moment.",
      "noRfqs": "Aucun appel d'offres pour le moment.",
      "noScorecardData": "Aucune donnée de scorecard pour le moment.",
      "useRfqsToSubmitQuotations": "Utilisez les appels d'offres pour soumettre des devis."
    },
    "labels": {
      "compositeScore": "Score composite"
    }
  },
  "formActions": {
    "submitTicket": "Soumettre le ticket"
  },
  "listActions": {
    "sendMagicLink": "Envoyer le lien magique",
    "confirmPod": "Confirmer la preuve de livraison"
  }
}
